import { ROLES } from '@/constants/roles';
import { IPlainObject } from '@/types/interfaces/PlainObject.interface';

export const DASHBOARD_NAMES: IPlainObject = {
  [ROLES.sole_trader]: 'user-dashboard',
  [ROLES.individual]: 'user-dashboard',
  [ROLES.merchant]: 'merchant-dashboard',
  DEFAULT: 'dashboard',
};
